import indicators from './indicators.js';

export default function(res, target, data) {
	indicators(res, target, data, 'financials');
}
